import lodash from 'lodash'

import type { Block, IBlockState, MapType, Section } from 'services/Store/Project/types'

interface IUseGetContinueDisable {
  block?: Block | null
  blocks: MapType<IBlockState>
  condition: 'last' | 'all' | 'none'
  section: Section | null
}

export const getContinueDisable = ({
  block,
  condition,
  blocks,
  section,
}: IUseGetContinueDisable) => {
  const prevBlocks =
    section?.blocksOrder.slice(0, section?.blocksOrder.indexOf(block?.uuid || '') || 0) || []

  const lastBlock = lodash.last(prevBlocks || []) || ''
  const blocksState = lodash.pick(blocks, prevBlocks)
  const isSomePrevBlocksIncomplete = lodash.some(blocksState, (el) => Boolean(el?.incomplete))
  const isLastBlockIncomplete = Boolean(blocks[lastBlock]?.incomplete)

  const disabledCondition = {
    last: isLastBlockIncomplete,
    all: isSomePrevBlocksIncomplete,
    none: false,
  }

  return disabledCondition[condition]
}
